import getVimeoThumbnail from "api/product/getVimeoThumbnail";

export const getVideosWithThumbnails = (videos: any) => Promise.all(
  videos.map((video: any) => {
    if (video.vimeoId) {
      return getVimeoThumbnail(video.vimeoId).then((data) => ({
        ...video,
        id: video.vimeoId,
        isVimeo: true,
        thumbnailUrl: data.thumbnail_url,
      }));
    }
    return {
      ...video,
      id: video.youtubeId,
      isVimeo: false,
      thumbnailUrl: `https://img.youtube.com/vi/${video.youtubeId}/sddefault.jpg`,
    };
  }),
);
